export const SESSION_STATUSES = {
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
};

export const TOPIC_STATUSES = {
  NEW: 'NEW',
  TITLE: 'TITLE',
  CONTENT: 'CONTENT',
  FILE: 'FILE',
  WATCHED: 'WATCHED',
  VOTING: 'VOTING',
};

export const VOTE_CONTENT_TYPES = {
  VOTING: 'VOTING',
  RESULT: 'RESULT',
  NONE: 'NONE',
  VOTED: 'VOTED',
  TITLE: 'TITLE',
  TOPIC: 'TOPIC',
  CONTENT: 'CONTENT',
  FILE: 'FILE',
  ABSENT: 'ABSENT',
  CLOSED: 'CLOSED',
  FORM: 'FORM',
  NEXT: 'NEXT',
  CHECK_PRESENT: 'CHECK_PRESENT',
};

export const VOTE_ANSWERS = {
  YES: 'YES',
  NO: 'NO',
  PAUSES: 'PAUSES',
  NONE: 'NONE',
};

export const VOTE_ACCESS_TYPES = {
  NONE: 'NONE',
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
};

export const TOPIC_VOTING_STATUSES = {
  WATCHED: 'WATCHED',
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
};
